/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Role_Software_DeveloperInputs */



/**
* | output |
* | --- |
* | "Software Developer" |
*
* @param {Team_Role_Software_DeveloperInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_role_software_developer = /** @type {((inputs?: Team_Role_Software_DeveloperInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Role_Software_DeveloperInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("软件开发工程师")
	return /** @type {LocalizedString} */ ("Software Developer")
});